import React from "react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleCheckIcon, InfoIcon, TriangleAlertIcon, OctagonXIcon, Loader2Icon } from "lucide-react"

import { cn } from "@/lib/utils"

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme()
  const theme = resolvedTheme === "dark" ? "dark" : "light"

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4 text-green-500" />,
        info: (
          <InfoIcon className="size-4 text-gray-500 dark:text-[color:var(--sidebar-muted-foreground)]" />
        ),
        warning: <TriangleAlertIcon className="size-4 text-[#F49113]" />,
        error: <OctagonXIcon className="size-4 text-red-500" />,
        loading: (
          <Loader2Icon className="size-4 animate-spin text-gray-500 dark:text-[color:var(--sidebar-muted-foreground)]" />
        ),
      }}
      toastOptions={{
        classNames: {
          toast: cn(
            "font-[family-name:var(--font-primary)]",
            "group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          ),
          description: "group-[.toast]:opacity-90",
          success: "!text-green-500",
          error: "!text-red-500",
          warning: "!text-[#F49113]",
          info: "!text-gray-600 dark:!text-white",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
